const burgerNav = {
    
    elements: {},

    burger: null,
    
    unBurger()
    {
        document.body.classList.remove('is-burger-expanded');
        this.elements.burgerContainer.classList.remove('is-active');
    },

    toggleBurger() {
        document.body.classList.toggle('is-burger-expanded');
        this.elements.burgerContainer.classList.toggle('is-active');
    },

    cacheDom() {
        this.elements.burger = document.querySelector('.js-burger');
        this.elements.burgerContainer = this.elements.burger.parentNode;
    },

    bind() {
        this.elements.burger.addEventListener('click', (e) => this.toggleBurger() );

        // this is interfering with mobile devices, where a resize event is fired when the bottom toolbar 
        // disappears
        window.addEventListener('resize', e => {
            if( window.matchMedia('(min-width: 1151px)').matches )
            {
                this.unBurger();
            }
        });
    },

    init() {
        this.cacheDom();
        if( this.elements.burger )
        {
            this.bind();
        }
    }
};

export default burgerNav;